(function () {
    // 注册组件
    SR.modules.extend('randomQuestions', randomQuestions);

    function randomQuestions() {
        var currentReqCount = 0;
        var maxReqCount = 5;
        var questionTimer;
        var duration = 3000;
        var urlSearch = location.search && location.search.replace('?', '');

        function fetchData() {
            $.ajax({
                method: 'POST',
                timeout: SR.data.xhrTimeout,
                url: '/questions?' + urlSearch,
            }).done(function (data) {
                if (data.ret === 0 && data.questions.length) {
                    setInputValue(data.questions);
                } else {
                    reload();
                }
            }).fail(function () {
                reload();
            }).always(function () {
                currentReqCount++;
            });
        }

        function setInputValue(questions) {
            var iQuestions = SR.util.shuffle(questions);
            var questionLen = iQuestions.length;
            var index = 0;

            questionTimer = setInterval(function () {
                if (index === questionLen) {
                    index = 0;
                }
                var q = iQuestions[index];
                if (SR.state.isH5) {
                    SR.dom.$askBar.find('.ask-bar-input').attr('data-presetContent', q).attr('placeholder', q);
                } else if (SR.state.isNative && !SR.state.isDebug && !SR.state.videoPlaying) {
                    upNativeComm.exec('smartRobot.setInputTextHint', {
                        'hint': q
                    });
                }
                index++;
            }, duration);
        }

        function reload() {
            if (maxReqCount === 5) {
                return;
            }
            fetchData();
        }

        fetchData();
    }
}());